import { useState } from "react";
import { Navbar } from "../components/landing/Navbar";
import { Hero } from "../components/landing/Hero";
import { Mission } from "../components/landing/Mission";
import { WhoBuys } from "../components/landing/WhoBuys";
import { LocalPickup } from "../components/landing/LocalPickup";
import { ProductsWeBuy } from "../components/landing/ProductsWeBuy";
import { HowItWorks } from "../components/landing/HowItWorks";
import { Requirements } from "../components/landing/Requirements";
import { JacksonvilleLocal } from "../components/landing/JacksonvilleLocal";
import { ResourceLinks } from "../components/landing/ResourceLinks";
import { FAQ } from "../components/landing/FAQ";
import { FinalCTA } from "../components/landing/FinalCTA";
import { ServiceArea } from "../components/landing/ServiceArea";
import { Footer } from "../components/landing/Footer";
import { SubmissionFormDialog } from "../components/landing/SubmissionFormDialog";
import { ContactDialog } from "../components/landing/ContactDialog";
import { MobileStickyBar } from "../components/seo/MobileStickyBar";

export default function LandingPage() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);

  const openForm = () => setIsFormOpen(true);
  const openContact = () => setIsContactOpen(true);

  return (
    <div className="min-h-screen bg-white">
      <Navbar onOpenForm={openForm} onOpenContact={openContact} />
      <Hero onOpenForm={openForm} onOpenContact={openContact} />
      <Mission />
      <WhoBuys onOpenForm={openForm} />
      <LocalPickup onOpenForm={openForm} />
      <ProductsWeBuy onOpenForm={openForm} />
      <HowItWorks onOpenForm={openForm} />
      <Requirements />
      <JacksonvilleLocal />
      <ResourceLinks />
      <FAQ />
      <FinalCTA onOpenForm={openForm} />
      <ServiceArea />
      <Footer />
      <MobileStickyBar onGetStarted={openForm} />

      <SubmissionFormDialog open={isFormOpen} onOpenChange={setIsFormOpen} />
      <ContactDialog open={isContactOpen} onOpenChange={setIsContactOpen} />
    </div>
  );
}
